<template>
    <div
        class="paypal-rest-form"
        data-env="production"
    >
        <div id="paypal-button-container" ref="buttonContainer"></div>
    </div>
</template>

<script>
export default {
    computed: {
        form() {
            return this.$el.closest('form');
        },
        prepare() {
            return `${window.location.origin}/actions/commerce/payments/pay`;
        },
        complete() {
            return `${window.location.origin}/actions/commerce/payments/complete-payment`;
        },
    },

    mounted() {
        this.loadPaypal();
    },

    beforeUnmount() {
        clearTimeout(this.timeout);
    },

    methods: {
        loadPaypal() {
            // eslint-disable-next-line camelcase
            if (typeof paypal_checkout_sdk === 'undefined') {
                this.timeout = setTimeout(this.loadPaypal, 200);
            } else {
                let transactionHash;
                let errorShown;

                // eslint-disable-next-line camelcase
                paypal_checkout_sdk.Buttons({
                    createOrder: (data, actions) => {
                        this.loading = true;

                        const form = new FormData(this.form);

                        return fetch(this.prepare, {
                            method: 'post',
                            body: form,
                            headers: {
                                Accept: 'application/json',
                            },
                        }).then((res) => {
                            return res.json();
                        }).then((data) => {
                            if (data.error) {
                                let errorMessage = '';

                                try {
                                    // Handle PayPal errors
                                    const error = JSON.parse(data.error);
                                    if (error.details && error.details.length) {
                                        errorMessage = error.details[0].description;
                                    }
                                } catch (e) {
                                    // Handle Commerce errors
                                    errorMessage = data.error;
                                }

                                throw Error(errorMessage);
                            }
                            ({ transactionHash } = data);
                            return data.transactionId; // Use the same key name for order ID on the client and server
                        }).catch((error) => {
                            errorShown = true;
                            alert(error);
                        });
                    },
                    onError: (err) => {
                        this.loading = false;
                        if (!errorShown) {
                            alert(err);
                        }
                    },
                    onApprove: (data, actions) => {
                        let separator = '?';
                        if (this.complete.indexOf('?') >= 0) {
                            separator = '&';
                        }

                        window.location = `${this.complete + separator}commerceTransactionHash=${transactionHash}`;
                    },
                }).render(this.$refs.buttonContainer);
            }
        },
    },
};
</script>
